<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red">
        <div class="headerCon acea-row row-between-wrapper">
          <div>
            <div class="name">申请人数</div>
            <div>
              <span class="num">{{spreadList.length}}</span
              >人
            </div>
          </div>
          <div class="iconfont icon-tuandui"></div>
        </div>
      </div>
      <div class="search acea-row row-between-wrapper">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="点击搜索会员名称" v-model="screen.name" />
            <span class="iconfont icon-guanbi" @click="screen.name = ''"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2" @click="submitForm"></div>
      </div>
    </div>
    <div class="list">
      <div 
        class="sortList"
        v-if="spreadList.length > 0"
        >
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item,index) in spreadList"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="item.avatar" /></div>
            <div class="text">
              <div class="name line1">{{item.nickname}}</div>
            </div>
          </div>
          <div class="right">
            <div 
              class="agree-apply-btn"
              @click="promoterApply(item.uid)"
              >同意</div>
          </div>
        </div>
      </div>
      <div v-else>
        <img src="@assets/images/noThing.png" width="100%">
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getSpreadUser } from "../../../api/user";
import { getPromoterApplyList ,  promoterApply} from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "AgentApplicationList",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      screen: {
        page: 1,
        limit: 10,
        name:""
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      loadTitle: "",
      first: "",
      second: ""
      //

    };
  },
  mounted: function() {
    this.getPromoterApplyList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getPromoterApplyList();
    });
  },
  watch: {
    "screen.sort": function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    }
  },
  methods: {
    promoterApply(id){
      let that = this;
      promoterApply(id).then(res=>{
        that.$dialog.success(res.msg);
        that.screen.page = 1;
        that.loaded = false;
        that.loading = false;
        that.spreadList = []
        that.getPromoterApplyList();
      }).catch(err=>{
        this.$dialog.error(err.msg);
      })
    },
    handleScroll: function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    submitForm: function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getPromoterApplyList();
    },
    
    getPromoterApplyList: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getPromoterApplyList(screen).then(
        res => {
          that.loading = false;
          that.spreadList.push.apply(that.spreadList, res.data);
          that.loaded = res.data.length < that.screen.limit; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.screen.page = that.screen.page + 1;
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    checkGrade: function(val) {
      if(val == this.screen.agent)return;
      // if (val == this.screen.grade) return;
      else {
        this.screen.page = 1;
        // this.screen.grade = val;
        this.screen.agent = val;
        this.loading = false;
        this.loaded = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
    },
    
  }
};
</script>
<style scoped>
.promoter-list .list .sortList{
  margin-top: 0 !important;
}
.promoter-list .list .item{
  height: 2rem;
}
.promoter-list .list .item .right{
  width: auto;
}
.agree-apply-btn{
  padding: .08rem .24rem;
  background: #9dccd0;
  text-align: center;
  color: #fff;
  border-radius: 25px;
}
</style>
